import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
type RyansTakeBlockquoteProps = {
  children?: React.ReactNode;
} & BoxProps;
export const RyansTakeBlockquote = t0 => {
  const $ = _c(6);
  let boxProps;
  let children;
  if ($[0] !== t0) {
    ({
      children,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = children;
  } else {
    boxProps = $[1];
    children = $[2];
  }
  let t1;
  if ($[3] !== boxProps || $[4] !== children) {
    t1 = <Box backgroundColor="colorPalette.muted" boxShadow="md" marginBottom={8} marginX="-2px" paddingX={5} paddingY={4} border="2px solid {colors.colorPalette.border}" borderRadius="md" {...boxProps}>{children}</Box>;
    $[3] = boxProps;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};